import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IGrid } from '@obvious.tech/constellation'

export const Grid = defineEntity('Grid', {
  endpoint: 'geolocation/api/Grid',
  schema: SNoop<IGrid>(),
})
